module.exports = __webpack_public_path__ + "01a14b7de90bda0ef2ad46fddf632d97.svg";